module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Fasting for Miracles")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('i', [_vm._v("As I considered the dedication for this manuscript, my first thought was of my three children, Jeremy, Joshua, and Jennifer. Miracles are gifts from God. Answers to prayers. Blessings and breakthroughs. That is what you are to me—miracles.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('i', [_vm._v("I have received love, encouragement, and joy from each of you. It is with a heart of gratitude that I thank God for my miracles. You are my gift from above.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0